export default "__VITE_ASSET__B_07KxVG__"